import {createSlice} from '@reduxjs/toolkit'

const bltReviewSlice = createSlice({
    name : "bltReview",
    initialState : {
        queueItem : null
    },
    reducers : {
        setQueueItem(state, action) { 
            state.queueItem = action.payload
        }, 
        setQueueItemReviewData(state, action) { 
            state.reviewData = action.payload
        }
    }
})

export const { 
    setQueueItem, 
    setQueueItemReviewData
} = bltReviewSlice.actions

export default bltReviewSlice.reducer
